// extracted by mini-css-extract-plugin
export var contrastLow = "_31-1";
export var externalLink = "_31-2";
export var externalLinkIcon = "_31-3";
export var link = "_31-0";
export var linkLabel = "_31-4";